import React from "react";

import ResumoSection from "../sections/ResumoSection";
import LojistaSection from "../sections/LojistaSection";
import OperacaoSection from "../sections/OperacaoSection";
import InformacoesCreditoSection from "../sections/InformacoesCreditoSection";
import InformacoesGarantiaSection from "../sections/InformacoesGarantiaSection";
import ConsultaSCRSection from "../sections/ConsultaSCRSection";
import FluxoConsolidadoSection from "../sections/FluxoConsolidadoSection";
import FluxoModalidadeSection from "../sections/FluxoModalidadeSection";
import InformacoesAdicionaisSection from "../sections/InformacoesAdicionaisSection";
import OutrasPropostasSection from "../sections/OutrasPropostasSection";
import { ComponentWrapper, CardWrapper, Label, Card } from "../styles";
import VeiculoTrocaSection from "../sections/VeiculoTrocaSection";

export const ListViewProposal = (props) => {
  const {
    proposalCompleteRegistration = {},
    proposalCompleteRegistrationLoading,
    proposalPartnetshipRegistration = {},
    proposalPartnetshipRegistrationLoading,
    proposalOperation = {},
    proposalOperationLoading,
    orderSummaryLoading,
    paymentTypes = {},
    paymentTypesLoading,
    operationTotalValue = {},
    proposalInfoWarranty = {},
    proposalInfoWarrantyLoading,
    proposalFluxoConsolidado = [],
    proposalFluxoConsolidadoLoading,
    proposalConsultaSCR = {},
    proposalConsultaSCRLoading,
    proposalFluxoModalidade = [],
    proposalFluxoModalidadeLoading,
    proposalWarrantyGuarantors = [],
    proposalWarrantyGuarantorsLoading,
    anotherOrderValues = [],
    anotherOrderValuesLoading,
    vehiclesOnExchange = [],
    vehiclesOnExchangeLoading,
    cpfCnpj,
    proposalNumber,
  } = props;

  return (
    <ComponentWrapper>
      <CardWrapper>
        <Label>Resumo</Label>
        <Card>
          <ResumoSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            numeroCpf={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            dataNascimento={proposalCompleteRegistration.dataNascimentoCliente}
            ufCliente={proposalCompleteRegistration.uf}
            rendaBruta={proposalCompleteRegistration.rendaBruta}
            profissao={proposalCompleteRegistration.descricaoProfissao}
            cargo={proposalCompleteRegistration.descricaoCargo}
            dataAdmissao={proposalCompleteRegistration.dataAdmissao}
            proposalWarrantyGuarantors={proposalWarrantyGuarantors}
            proposalWarrantyGuarantorsLoading={
              proposalWarrantyGuarantorsLoading
            }
            nomeAnalista={proposalCompleteRegistration.nomeAnalista}
            descricaoStatus={proposalCompleteRegistration.descricaoStatus}
            tipoPessoa={proposalCompleteRegistration.tipoPessoa}
            numeroCnpj={proposalCompleteRegistration.cpfCnpj}
            razaoSocial={proposalCompleteRegistration.nomeCliente}
            nomeFantasia={proposalCompleteRegistration.nomeClienteResumido}
            dataFundacao={proposalCompleteRegistration.dataFundacao}
            inscricaoEstadual={proposalCompleteRegistration.inscricaoEstadual}
            inscricaoMunicipal={proposalCompleteRegistration.inscricaoMunicipal}
            codigoRamoAtividade={
              proposalCompleteRegistration.codigoRamoAtividade
            }
            descricaoRamoAtividade={
              proposalCompleteRegistration.descricaoRamoAtividade
            }
            porteEmpresa={proposalCompleteRegistration.porteEmpresa}
            codigoCnae={proposalCompleteRegistration.codigoCnae}
            descricaoCnae={proposalCompleteRegistration.descricaoCnae}
            faturamentoAnual={proposalCompleteRegistration.faturamentoAnual}
            rankingRelacionamento={
              proposalCompleteRegistration.rankingRelacionamento
            }
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Lojista</Label>
        <Card>
          <LojistaSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            nomeConvenio={proposalCompleteRegistration.nomeConvenio}
            nomeAgente={proposalCompleteRegistration.nomeAgente}
            ratingFilial={proposalCompleteRegistration.ratingFilial}
            nomeFilial={proposalCompleteRegistration.nomeFilial}
            ufFilial={proposalCompleteRegistration.ufFilial}
            nomeFilialFantasia={proposalCompleteRegistration.nomeFilialFantasia}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Operação</Label>
        <Card>
          <OperacaoSection
            proposalOperationLoading={proposalOperationLoading}
            numeroProposta={proposalOperation.numeroProposta}
            produto={proposalOperation.produto}
            pedidoOrcamento={proposalOperation.pedidoOrcamento}
            valorProposta={proposalOperation.valorProposta}
            cetAm={proposalOperation.cetAm}
            taxaMes={proposalOperation.taxaMes}
            taxaReal={proposalOperation.taxaReal}
            quantidadePrestacoes={proposalOperation.quantidadePrestacoes}
            valorPrestacao={proposalOperation.valorPrestacao}
            retorno={proposalOperation.retorno}
            operationTotalValue={operationTotalValue}
            orderSummaryLoading={orderSummaryLoading}
            spf={proposalOperation.spf}
            spm={proposalOperation.spm}
            anotherOrderValues={anotherOrderValues}
            anotherOrderValuesLoading={anotherOrderValuesLoading}
            paymentTypesLoading={paymentTypesLoading}
            paymentTypes={paymentTypes}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Veículo na troca</Label>
        <Card>
          <VeiculoTrocaSection
            proposalOperationLoading={proposalOperationLoading}
            operationTotalValue={operationTotalValue}
            vehiclesOnExchange={vehiclesOnExchange}
            vehiclesOnExchangeLoading={vehiclesOnExchangeLoading}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Informações de crédito</Label>
        <Card>
          <InformacoesCreditoSection
            proposalOperationLoading={proposalOperationLoading}
            valorGarantia={proposalInfoWarranty.valorGarantia}
            percentualGarantia={proposalInfoWarranty.percentualGarantia}
            comprometimentoRenda={proposalOperation.comprometimentoRenda}
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Informações da garantia</Label>
        <Card>
          <InformacoesGarantiaSection
            proposalInfoWarrantyLoading={proposalInfoWarrantyLoading}
            veiculo={proposalInfoWarranty.veiculo}
            ano={proposalInfoWarranty.ano}
            modelo={proposalInfoWarranty.modelo}
            placa={proposalInfoWarranty.placa}
            uf={proposalInfoWarranty.uf}
            codigoFipe={proposalInfoWarranty.codigoFipe}
            valorMercado={proposalInfoWarranty.valorMercado}
            chassi={proposalInfoWarranty.chassi}
            debitosVeiculo={proposalInfoWarranty.debitosVeiculo}
            situacao={proposalInfoWarranty.situacao}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Consulta SCR - Bacen</Label>
        <Card>
          <ConsultaSCRSection
            proposalConsultaSCRLoading={proposalConsultaSCRLoading}
            numeroCpfCnpj={proposalConsultaSCR.numeroCpfCnpj}
            nomeCliente={proposalConsultaSCR.nomeCliente}
            dataBase={proposalConsultaSCR.dataBase}
            qtdeOperacoes={proposalConsultaSCR.qtdeOperacoes}
            qtdeIFs={proposalConsultaSCR.qtdeIFs}
            qtdeOperacoesSubJudice={proposalConsultaSCR.qtdeOperacoesSubJudice}
            qtdeOperacoesDiscordancia={
              proposalConsultaSCR.qtdeOperacoesDiscordancia
            }
            inicioRelacionamento={proposalConsultaSCR.inicioRelacionamento}
            ultimaConsulta={proposalConsultaSCR.ultimaConsulta}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Fluxo consolidado (valores em R$ mil)</Label>
        <Card>
          <FluxoConsolidadoSection
            proposalFluxoConsolidadoLoading={proposalFluxoConsolidadoLoading}
            proposalFluxoConsolidado={proposalFluxoConsolidado}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Fluxo por modalidade (valores em R$ mil)</Label>
        <Card>
          <FluxoModalidadeSection
            proposalFluxoModalidadeLoading={proposalFluxoModalidadeLoading}
            proposalFluxoModalidade={proposalFluxoModalidade}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Informações adicionais</Label>
        <Card>
          <InformacoesAdicionaisSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            observacoes={proposalCompleteRegistration.observacoes}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Outras propostas</Label>
        <Card>
          <OutrasPropostasSection
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
          />
        </Card>
      </CardWrapper>
    </ComponentWrapper>
  );
};

export default ListViewProposal;
